import { useEffect, useState } from 'react'
import { fetchProductFieldDefinitions } from './shopRuntimeApi'
import type { CatalogProductFieldDefinition } from '../types'

export const useShopFieldDefinitions = () => {
  const [productFieldDefinitions, setProductFieldDefinitions] = useState<CatalogProductFieldDefinition[]>([])

  useEffect(() => {
    let alive = true
    const controller = new AbortController()

    const loadDefinitions = async () => {
      try {
        const fields = await fetchProductFieldDefinitions(controller.signal)
        if (!alive) return
        setProductFieldDefinitions(fields)
      } catch {
        if (!alive) return
        setProductFieldDefinitions([])
      }
    }

    void loadDefinitions()

    return () => {
      alive = false
      controller.abort()
    }
  }, [])

  return {
    productFieldDefinitions,
  }
}
